module.exports = "/static/assets/5746ae12ca84ea004e747f32438337da.png";